import { basePath,apiVersion } from "./config";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../utils/constants";


export async function login(data) {
  try {
    const url = `${basePath}/${apiVersion}/auth/login`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json();

    if (response.status !== 200) throw result;

    return result;
  } catch (error) {
    throw error;
  }
}


export async function refreshAccessToken(refreshToken) {
  try {
    const url = `${basePath}/${apiVersion}/refresh_access_token`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: refreshToken,
      }),
    };

    const response = await fetch(url, params);
    const result = await response.json();

    if (response.status !== 200) throw result;

    return result;
  } catch (error) {
    throw error;
  }
}

export function setAccessToken(token) {
  localStorage.setItem(ACCESS_TOKEN, token);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN);
}

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN,token);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN);
}

export function removeTokens() {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
}